import {
  apiLoadCrossTable
} from '../api/apiObservables';
import apiHelper from '../../utilities/apiObsHelpers'

export const GETTER_TABLE_ROW_CATEGORY = 'analytics/table/getRow';
export const GETTER_TABLE_COLUMN_CATEGORY = 'analytics/table/getColumn';
export const GETTER_TABLE_RESULT = 'analytics/table/getResult';

export const MUTATE_ROW_CATEGORY = 'analytics/mortality/mutateRow';
export const MUTATE_COLUMN_CATEGORY = 'analytics/mortality/mutateColumn';
export const MUTATE_TABLE_RESULT = 'analytics/mortality/mutateResult';

export const ACTION_LOAD_TABLE_RESULT = 'analytics/table/loadTable';

const state = {
  row: {},
  column: {},
  result: []
};

const getters = {
  [GETTER_TABLE_ROW_CATEGORY]: (state) => state.row,
  [GETTER_TABLE_COLUMN_CATEGORY]: (state) => state.column,
  [GETTER_TABLE_RESULT]: (state) => state.result
};

const mutations = {
  [MUTATE_ROW_CATEGORY]: (state, payload) => {
    state.row = payload
  },
  [MUTATE_COLUMN_CATEGORY]: (state, payload) => {
    state.column = payload
  },
  [MUTATE_TABLE_RESULT]: (state, payload) => {
    state.result = payload
  }
};

const actions = {
  [ACTION_LOAD_TABLE_RESULT]: apiHelper.mutateResult(
    apiLoadCrossTable,
    MUTATE_TABLE_RESULT)
};

export default {
  state,
  getters,
  mutations,
  actions
}
